import { SiteHeader } from '@/components/layout/SiteHeader';
import { SiteFooter } from '@/components/layout/SiteFooter';
import { ComparisonSection } from '@/components/landing/sections/ComparisonSection';
import { useDocumentMeta } from '@/lib/useDocumentMeta';

export function ComparePage() {
  useDocumentMeta({
    title: 'Compare — CadencEZ vs Loglass, Pigment, Anaplan, Cube',
    description:
      'How CadencEZ stacks up against Loglass, Pigment, Anaplan, and Cube on transparency, AI provenance, and per-seat list pricing. Every row is verifiable today.',
    path: '/compare',
  });

  return (
    <div className="min-h-screen flex flex-col">
      <SiteHeader />
      <main className="flex-1">
        <ComparisonSection hideFullLink />
      </main>
      <SiteFooter />
    </div>
  );
}

export default ComparePage;
